






import { Vue, Component, State, namespace } from 'nuxt-property-decorator'

const ActivityModule = namespace('traveller/activity')

@Component({
  components: {}
})

export default class ExperienceFilterModal extends Vue {
  @State klook!: Data.Klook
  @ActivityModule.State cityName!: string

  modalShow: boolean = false
  action(e: any) {
    // 判断用户的点击行为是否在 input 框和弹层上
    // 若不是，则收起弹层
    if (this.$refs.filterModal) {
      if (!((this.$refs.filterModal as HTMLElement).contains(e.target)) && this.modalShow) {
        this.$emit('hide')
      }
      this.modalShow = true
    }
  }

  mounted() {
    document.addEventListener('click', this.action)
  }

  beforeDestory() {
    document.removeEventListener('click', this.action)
  }
}
